export default {
  name: "OverviewSummary",

  // components: {
  //   WelcomeBack,
  //   OverviewSummary,
  // },

  props: {
    summary_items: {
      type: Array,
      default: () => [
        { label: "Number of Properties", value: "35" },
        { label: "Daily Foot Traffic", value: "19.3k" },
        { label: "Active Cameras", value: "461 / 500" },
        { label: "Bandwidth Usage", value: "77.48%" },
        { label: "Total Grid Power", value: "3.64k kW" },
        { label: "Total Water Volume", value: "16.1k kL" },
      ],
    },
  },
};
